import { render, staticRenderFns } from "./GItemTableImage.vue?vue&type=template&id=12872db4&scoped=true&"
import script from "./GItemTableImage.vue?vue&type=script&lang=ts&"
export * from "./GItemTableImage.vue?vue&type=script&lang=ts&"
import style0 from "./GItemTableImage.vue?vue&type=style&index=0&id=12872db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12872db4",
  null
  
)

export default component.exports